import React, { useState, useEffect } from 'react';
import './App.css';
import AvailabilityCalendar from './components/AvailabilityCalendar';
import tokenManager from './utils/tokenManager';
import apiConfig from './utils/apiConfig';

// 初期化時に設定
if (process.env.REACT_APP_TOKEN_ENDPOINT) {
  tokenManager.setTokenEndpoint(process.env.REACT_APP_TOKEN_ENDPOINT);
}

if (process.env.REACT_APP_API_URL_ENDPOINT) {
  apiConfig.setApiUrlEndpoint(process.env.REACT_APP_API_URL_ENDPOINT);
}

function App({ params = {} }) {
	// params は埋め込み側から渡されるオブジェクト。
	// 単一の場合: { bus_type_id: '4', pref_id: '8_0' }
	// 全種類表示: { bus_type_id: '0', pref_id: '8_0' }
	const [prefId, setPrefId] = useState(params.pref_id || '8_0');
	const [busTypeId, setBusTypeId] = useState(params.bus_type_id || '4');

	
	// 三日後の日付を取得（時刻は0:00に設定）
	const getMinSelectableDate = () => {
		// params.start_timeがある場合はそれを使用
		if (params.start_time) {
			const date = new Date(params.start_time * 1000);
			date.setHours(0, 0, 0, 0);
			return date;
		}
		
		// デフォルトは3日後
		const date = new Date();
		date.setDate(date.getDate() + 3);
		date.setHours(0, 0, 0, 0);
		return date;
	};
	
	const [minSelectableDate] = useState(getMinSelectableDate());

	// バスタイプのループ設定
	// bus_type_id が "0" の場合は、全バスタイプを表示
	// それ以外は単一のバスタイプを配列化
	const busTypeIds = (params.bus_type_id === '0' || params.bus_type_id === 0) 
		? ['4', '12', '3'] 
		: [params.bus_type_id || busTypeId];
	
	// 表示・非表示の制御（デフォルトは両方表示）
	const showPrefSelect = params.show_pref !== false;
	const showBusTypeSelect = params.show_bus_type !== false;

	// 埋め込み側からの params を後から変更したい場合に備え
	useEffect(() => {
		if (params.pref_id) setPrefId(params.pref_id);
		if (params.bus_type_id) setBusTypeId(params.bus_type_id);
	}, [params.pref_id, params.bus_type_id]);

	// 複数のカレンダーを生成（バスタイプごと）
	const generateCalendars = () => {
		return busTypeIds.map((busType, index) => ({
			id: index,
			busTypeId: busType,
			appParams: {
				bus_type_id: busType,
				pref_id: prefId,
				min_selectable_date: minSelectableDate,
				start_time: params.start_time || null,
				end_time: params.end_time || null,
				bus_count: params.bus_count || '1',
				bus_guide: params.bus_guide || '0',
				fid: params.fid || '1',
				use_type: params.use_type || '1'
			}
		}));
	};

	const calendars = generateCalendars();

	return (
		<div className="App">
			<div className="container">
				{calendars.map((calendar) => (
					<div key={`calendar-${calendar.id}`} className="calendar-section">
						<AvailabilityCalendar 
							appParams={calendar.appParams} 
						/>
					</div>
				))}
				
				<div className="select-container">
					{showPrefSelect && (
						<div className="select-group">
							<label htmlFor="area-select">出発地</label>
							<select 
								id="area-select" 
								value={prefId} 
								onChange={(e) => setPrefId(e.target.value)}
								className="select-box"
							>
								<option value="">選択してください</option>
								<optgroup label="北海道・東北">
									<option value="1_0">北海道</option>
									<option value="2_0">青森県</option>
									<option value="3_0">岩手県</option>
									<option value="4_0">宮城県</option>
									<option value="5_0">秋田県</option>
									<option value="6_0">山形県</option>
									<option value="7_0">福島県</option>
								</optgroup>
								<optgroup label="関東">
									<option value="8_0">東京都</option>
									<option value="9_0">神奈川県</option>
									<option value="10_0">埼玉県</option>
									<option value="11_0">千葉県</option>
									<option value="12_0">茨城県</option>
									<option value="13_0">栃木県</option>
									<option value="14_0">群馬県</option>
									<option value="15_0">山梨県</option>
								</optgroup>
								<optgroup label="信越・北陸">
									<option value="16_0">新潟県</option>
									<option value="17_0">長野県</option>
									<option value="18_0">富山県</option>
									<option value="19_0">石川県</option>
									<option value="20_0">福井県</option>
								</optgroup>
								<optgroup label="東海">
									<option value="21_0">愛知県</option>
									<option value="22_0">岐阜県</option>
									<option value="23_0">静岡県</option>
									<option value="24_0">三重県</option>
								</optgroup>
								<optgroup label="近畿">
									<option value="25_0">大阪府</option>
									<option value="26_0">兵庫県</option>
									<option value="27_0">京都府</option>
									<option value="28_0">滋賀県</option>
									<option value="29_0">奈良県</option>
									<option value="30_0">和歌山県</option>
								</optgroup>
								<optgroup label="中国">
									<option value="31_0">鳥取県</option>
									<option value="32_0">島根県</option>
									<option value="33_0">岡山県</option>
									<option value="34_0">広島県</option>
									<option value="35_0">山口県</option>
								</optgroup>
								<optgroup label="四国">
									<option value="36_0">徳島県</option>
									<option value="37_0">香川県</option>
									<option value="38_0">愛媛県</option>
									<option value="39_0">高知県</option>
								</optgroup>
								<optgroup label="九州・沖縄">
									<option value="40_0">福岡県</option>
									<option value="41_0">佐賀県</option>
									<option value="42_0">長崎県</option>
									<option value="43_0">熊本県</option>
									<option value="44_0">大分県</option>
									<option value="45_0">宮崎県</option>
									<option value="46_0">鹿児島県</option>
									<option value="47_0">沖縄県</option>
								</optgroup>
							</select>
						</div>
					)}

					{showBusTypeSelect && (
						<div className="select-group">
							<label htmlFor="bustype-select">バスタイプ</label>
							<select 
								id="bustype-select" 
								value={busTypeId} 
								onChange={(e) => setBusTypeId(e.target.value)}
								className="select-box"
							>
								<option value="">選択してください</option>
								<option value="12">小型マイクロバス</option>
								<option value="4">大型バス</option>
								<option value="3">中型バス</option>
							</select>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default App;
